module.exports = __webpack_public_path__ + "img/moto-azul-escuro.88ad4ae4.png";